import { render } from "./FooterRewardNew.vue?vue&type=template&id=581041e8&scoped=true"
import script from "./FooterRewardNew.vue?vue&type=script&lang=js"
export * from "./FooterRewardNew.vue?vue&type=script&lang=js"

import "./FooterRewardNew.vue?vue&type=style&index=0&id=581041e8&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-581041e8"]])

export default __exports__